import gql from 'graphql-tag';

export default gql`
mutation ($id: String!) {
    deleteAdvertiser (input: { id: $id }) {
        __typename
        id
        name
    }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/Users/DeleteMutation.js